const prefix = 'CONTROL_INFO';

export const GET_HACCP_LOADING = `${prefix}_GET_HACCP_LOADING`;
export const GET_HACCP_SUCCESS = `${prefix}_GET_HACCP_SUCCESS`;
export const GET_HACCP_ERROR = `${prefix}_GET_HACCP_ERROR`;

export const WRITE_HACCP_LOADING = `${prefix}_WRITE_HACCP_LOADING`;
export const WRITE_HACCP_SUCCESS = `${prefix}_WRITE_HACCP_SUCCESS`;
export const WRITE_HACCP_ERROR = `${prefix}_WRITE_HACCP_ERROR`;

export const GET_HACCP_TYPE_LOADING = `${prefix}_GET_HACCP_TYPE_LOADING`;
export const GET_HACCP_TYPE_SUCCESS = `${prefix}_GET_HACCP_TYPE_SUCCESS`;
export const GET_HACCP_TYPE_ERROR = `${prefix}_GET_HACCP_TYPE_ERROR`;

export const WRITE_HACCP_TYPE_LOADING = `${prefix}_WRITE_HACCP_TYPE_LOADING`;
export const WRITE_HACCP_TYPE_SUCCESS = `${prefix}_WRITE_HACCP_TYPE_SUCCESS`;
export const WRITE_HACCP_TYPE_ERROR = `${prefix}_WRITE_HACCP_TYPE_ERROR`;

export const DELETE_HACCP_TYPE_LOADING = `${prefix}_DELETE_HACCP_TYPE_LOADING`;
export const DELETE_HACCP_TYPE_ERROR = `${prefix}_DELETE_HACCP_TYPE_ERROR`;
export const DELETE_HACCP_TYPE_SUCCESS = `${prefix}_DELETE_HACCP_TYPE_SUCCESS`;

export const DELETE_HACCP_LOADING = `${prefix}_DELETE_HACCP_LOADING`;
export const DELETE_HACCP_ERROR = `${prefix}_DELETE_HACCP_ERROR`;
export const DELETE_HACCP_SUCCESS = `${prefix}_DELETE_HACCP_SUCCESS`;

export const CLEAR_ERROR = `${prefix}_CLEAR_ERROR`;



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/haccp/types.js